import React, { useState } from "react";
import PropTypes from "prop-types";
import { IconButton, Popover, Box, Typography } from "@mui/material";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";


const InfoIcon = ({ infoText, color }) => {
    if (!infoText) {
        return <></>;
    }

    const [anchorEl, setAnchorEl] = useState(null);

    const handleInfoClick = event => {
        setAnchorEl(anchorEl ? null : event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const open = Boolean(anchorEl);

    return (
        <>
            <IconButton
                sx={{
                    padding: "6px",
                    backgroundColor: "transparent"
                }}
                onClick={handleInfoClick}
            >
                <InfoOutlinedIcon sx={{
                    width: "16px",
                    height: "16px",
                    fill: color
                }}/>
            </IconButton>

            <Popover
                open={open}
                anchorEl={anchorEl}
                onClose={handleClose}
                anchorOrigin={{
                    vertical: "bottom",
                    horizontal: "left",
                }}
                transformOrigin={{
                    vertical: "top",
                    horizontal: "left",
                }}
            >
                <Box p={1} maxWidth={300}>
                    <Typography variant="body2">{infoText}</Typography>
                </Box>
            </Popover>
        </>
    );
};

InfoIcon.propTypes = {
    infoText: PropTypes.string,
};
export default InfoIcon;